exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg{background-color:#d3d3d3}.h4-t{margin-top:-9px}.h4-c,.h4-t{margin-bottom:-5px;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-439e4b12","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cardprinting/studentprofilesummaryprint.vue
// module id = 599
// module chunks = 0